import {Sprites} from './UIGameImageDictionary'
import {HolidayDateUtils} from '../HolidayDateUtils'

class UIGameRobberSkinController {
    private readonly chosenSkin: Sprites

    constructor() {
        const holiday = HolidayDateUtils.getCurrentHoliday()
        switch(holiday) {
            case 'valentines': {
                this.chosenSkin = Sprites.icon_robber_cupid
                break
            }
            case 'christmas': {
                this.chosenSkin = Sprites.icon_robber_santa
                break
            }
            default: break
        }

        if(this.chosenSkin == undefined) this.chosenSkin = Sprites.icon_robber
    }

    getRobberSkin(): Sprites {
        return this.chosenSkin
    }
}

export const robberSkinController = new UIGameRobberSkinController()
